import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData } from '../../../types'
import { CmsConverterService, defaultLinkData } from '../../../../services/cms-converter/cms-converter.service'
import { CmsLinkType } from '../../../../enums/cms-link-type'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedHandbookArticlesLinkConverter extends CmsConverterService<PanelRowRelatedHandbookArticlesLinkData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const link = formData.st_panel_row_related_handbook_arcticle_link ?? defaultLinkData
    link.uid = CmsLinkType.CONTENT_LINK
    return {
      link
    }
  }
}

export const PANEL_ROW_RELATED_HANDBOOK_ARTICLES_LINK_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedHandbookArticlesLinkData>>('PanelRowRelatedHandbookArticlesLinkConverter')

export interface PanelRowRelatedHandbookArticlesLinkData extends ConvertedComponentData {
  link: LinkData;
}
